module.exports = __webpack_public_path__ + "img/one-drive-icon.497c151b.svg";